module.exports = {"apiURL":"http://test-vr-editor.pantheonsite.io","clientId":"16b0ed87-7116-40d2-9b26-354af3b2deb3"}


//////////////////
// WEBPACK FOOTER
// ./src/config/development.json
// module id = 2330
// module chunks = 0